import axios from './axios.service'
import authHeader from './auth-header'
const FileSaver = require('file-saver')

const token = authHeader()
const method = 'newsletters'

class NewsletterService {
  async index(queryData) {
    try {
      const response = await axios.get(`/${method}`, {
        headers: token,
        params: { ...queryData }
      })
      return response.data
    } catch (error) {
      return error
    }
  }

  async show(id) {
    try {
      const response = await axios({
        method: 'get',
        url: `/${method}/${id}`
      })
      return response.data
    } catch (error) {
      return error
    }
  }

  async updateStatus(rowClicked, status) {
    try {
      const response = await axios({
        method: 'put',
        url: `/${method}/status/${rowClicked.id}`,
        data: {
          status
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async deleteItem(rowClicked) {
    try {
      const response = await axios.delete(`/${method}/${rowClicked.id}`)
      return response
    } catch (error) {
      return error
    }
  }

  async forceDelete(id) {
    try {
      const response = await axios.delete(`/${method}/${id}/forcedelete`)
      return response
    } catch (error) {
      return error
    }
  }

  async store(data) {
    try {
      const response = await axios({
        method: 'post',
        url: `/${method}`,
        data
      })
      return response
    } catch (error) {
      return error
    }
  }

  async update(id, data) {
    try {
      const response = await axios({
        method: 'put',
        url: `/${method}/${id}`,
        data
      })
      return response
    } catch (error) {
      return error
    }
  }

  async exportXLS() {
    try {
      const file = await axios({
        method: 'get',
        url: `/export/${method}`,
        responseType: 'blob'
      })
      const xls = file.request.response
      FileSaver.saveAs(xls, 'newsletters.xlsx')
    } catch (error) {
      return error
    }
  }
}

export default new NewsletterService()
